import jQuery from 'jquery';
import underscore from 'underscore';
import '../../../dist/css/style.css';

window.$ = jQuery;
window._ = underscore;


// checkbox
$('.form-checkbox').on('click', function () {
  $(this).toggleClass('selected');
});




// WEBPACK FOOTER //
// src/components/helper-modules/entry-base.jsx